import { AppService } from './AppService';

export class PortabiliteService{
    appService = new AppService();
    constructor(){
       
    }

    isClientSfr(numero) {
        const url = this.appService.getApiUrl()+'portabilite/portabilite.php';
        const params = {
            numero: numero,
            action: 'isClientSfr'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    checkRio(numero, codeRIO, domaine, site,offreChoisieType) {
        const url = this.appService.getApiUrl()+'portabilite/portabilite.php';
        const params = {
            numero: numero,
            codeRIO:codeRIO,
            domaine: domaine,
            site: site,
            offreChoisieType: offreChoisieType,
            action: 'checkRio'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    simValidate(simCode, domaine, site) {
        const url = this.appService.getApiUrl()+'portabilite/portabilite.php';
        const params = {
            simCode: simCode,
            domaine: domaine,
            site: site,
            action: 'simValidate'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }



}